import { ref, computed, Ref, reactive } from 'vue'
import { ElMessage as message } from 'element-plus'
import { t } from '@/plugins/i18n'
import cache from '@/plugins/cache'
import { MobileCodeParams } from '@/apis/login'

export enum LoginMode {
  password = 'password',
  email = 'email',
  phone = 'phone'
}
/**
 * 获取手机验证码
 * @param record
 * @param fapi
 * @param mapi
 * @returns
 */
export const useGetCode = (record: string, EmailApi: any, PhoneApi: any = null): any => {
  const disabled = ref(true)
  const loading = ref(false)
  let timer: any = null
  const count = ref(0)
  const tick = () => {
    timer = setInterval(() => {
      count.value--
      if (count.value <= 0) {
        cache.delete(record)
        clearInterval(timer)
      }
    }, 1000)
  }

  const prev = cache.get(record)
  if (prev) {
    if (prev <= 0) {
      cache.get(record)
    } else {
      const value = 60 - Math.ceil((Date.now() - prev) / 1000)
      count.value = value <= 0 ? 0 : value
      count.value > 0 && tick()
    }
  }

  const startCount = () => {
    cache.set(record, Date.now())
    count.value = 60
    tick()
  }

  const getEmailCode = (customerEmail: string, api: any = EmailApi, ...rest: any[]): any => {
    // 倒计时未结束，无法再次发起
    if (count.value > 0) return
    let frag = false
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loading.value || frag) {
          return false
          // message.warning(t('已发送验证码请求，请勿重复发送请求'))
        } else if (disabled.value) {
          message.error(t('邮箱格式不正确，请重新输入'))
          resolve(false)
        } else {
          loading.value = true
          frag = true
          api(customerEmail, ...rest)
            .then((res: any) => {
              loading.value = false
              frag = false
              if (res.success) {
                message.success(t('验证码正在发送，请注意查收'))
                resolve(true)
                startCount()
              } else {
                // message.error(res.msg)
                resolve(false)
              }
            })
            .catch((err: Error): void => {
              loading.value = false
              frag = false
              console.log(err)
            })
        }
      })
    })
  }
  /** 获取手机号验证码 */
  const getPhoneCode = (params: MobileCodeParams, api = PhoneApi): Promise<boolean> => {
    let frag = false
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loading.value || frag) {
          return false
          // message.warning(t('已发送验证码请求，请勿重复发送请求'))
        } else if (disabled.value) {
          message.error(t('请重新输入正确的手机号'))
          resolve(false)
        } else {
          loading.value = true
          frag = true
          api(params)
            .then((res: any) => {
              loading.value = false
              frag = false
              if (res.success) {
                message.success(t('验证码正在发送，请注意查收'))
                resolve(true)
                startCount()
              } else {
                resolve(false)
              }
            })
            .catch((err: Error): void => {
              loading.value = false
              frag = false
              console.log(err)
            })
        }
      })
    })
  }
  const text = t('已发送')
  const tip = computed(() => {
    return `${text}(${count.value})`
  })

  return { count, tip, disabled, getCode: getEmailCode, getPhoneCode }
}

export const useLoading = <T, R>(
  api: (...rest: R[]) => Promise<T>
): [Ref, (...rest: R[]) => Promise<T | undefined>] => {
  const loading = ref(false)
  const wrap = async (...rest: R[]): Promise<T | undefined> => {
    try {
      loading.value = true
      const res = await api(...rest)
      return res
    } catch (error) {
      loading.value = false
    }
  }
  return [loading, wrap]
}
